<!--
component: AppFooter
author: Ken Nakamura
description: フッタ
-->
<template>
  <v-footer
    dark
    absolute
    color="#334455"
    class="fixed-bottom footer"
  >
    <div class="footer">
      {{ caption }}
    </div>
  </v-footer>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: 'Copyright 2021. All right reserved'
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  margin: auto;
}

@media print {
  .footer {
    display: none;
  }
}
</style>
